"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilkomedaProvider = exports.inject = void 0;
var provider_1 = require("./provider");
exports.MilkomedaProvider = provider_1.default;
var inject = function (oracleUrl, jsonRpcProviderUrl, cardanoWallet) {
    window.ethereum = new provider_1.default(oracleUrl, jsonRpcProviderUrl, cardanoWallet);
    return window.ethereum;
};
exports.inject = inject;
